import(/* webpackMode: "eager", webpackExports: ["LegalScreen"] */ "/vercel/path0/src/features/marketing/LegalScreen.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/application-utilities.css");
